import { render, staticRenderFns } from "./GreenOperationDocuments.vue?vue&type=template&id=75c819e4&scoped=true&"
import script from "./GreenOperationDocuments.vue?vue&type=script&lang=js&"
export * from "./GreenOperationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationDocuments.vue?vue&type=style&index=0&id=75c819e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c819e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c819e4')) {
      api.createRecord('75c819e4', component.options)
    } else {
      api.reload('75c819e4', component.options)
    }
    module.hot.accept("./GreenOperationDocuments.vue?vue&type=template&id=75c819e4&scoped=true&", function () {
      api.rerender('75c819e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/GreenOperationDocuments.vue"
export default component.exports